export default {
  common: {
    close: '关闭',
    cancel: '取消',
    login: '登录',
    register: '注册',
    logout: '退出登录',
    langZh: '中文',
    langEn: 'English',
    userFallback: '用户'
  },
  homepage: {
    flowTagline: '简历，重新构想。',
    flowTitle: 'AI 简历与求职助手',
    flowSubtitle: '获取与简历匹配的职位推荐，或个性化的技能提升建议。AI 智能匹配与指导。',
    ctaJobRecommendations: '职位推荐',
    ctaJobRecommendationsDesc: '发现与您简历匹配的职位。AI 智能匹配与推荐理由。',
    ctaSkillAdvice: '技能提升建议',
    ctaSkillAdviceDesc: '根据您的简历获取个性化的技能提升建议。',
    ctaInterviewDebrief: '面试复盘',
    ctaInterviewDebriefDesc: '记录面试经历并提炼收获。获得总结与可执行的改进建议。',
    howItWorksTitle: '如何使用',
    howItWorksStep1: '上传或粘贴您的简历',
    howItWorksStep2: '请求职位推荐或技能建议',
    howItWorksStep3: '获取 AI 智能匹配和个性化指导',
    benefitsTitle: '优势',
    benefitUploadNoLogin: '无需登录即可上传简历',
    benefitJobExplanations: '职位推荐附带推荐理由',
    benefitSkillAdvice: '个性化技能提升建议',
    benefitAIGuidance: 'AI 智能匹配与指导',
    legacyEditor: '切换至传统编辑器'
  },
  app: {
    title: '智能求职助手',
    headerLogo: '智能求职助手',
    subtitle: '上传简历，用幽默风格改写',
    navJobRecommendations: '职位推荐',
    navInterviewDebrief: '面试复盘',
    resumeLibrary: '简历库',
    inviteFriends: '邀请好友',
    welcome: '欢迎，{name}',
    footerCopy: "AI 简历与求职助手 © {year} {'|'} DeepSeek 驱动",
    footerCopyPrefix: "AI 简历与求职助手 © {year} {'|'} ",
    footerCopySuffix: ' 驱动',
    announcementText: '新功能：职位推荐 — 根据简历匹配合适职位。',
    announcementLinkLabel: '立即体验',
    footerProduct: '产品',
    footerSkillAdvice: '技能提升建议',
    footerLegalSafety: '法律与安全',
    termsNoticePrefix: '使用 AI 简历编辑器即表示您同意 ',
    termsNoticeSuffix: ' 并已阅读 ',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    policeAlt: '公安备案'
  },
  resumeLibrary: {
    back: '← 返回',
    title: '简历库',
    subtitle: '存储和管理您的简历，随时下载用于面试。',
    quota: '{count}/5 份简历',
    uploadNew: '上传新简历',
    uploading: '上传中…',
    uploadHint: '仅 PDF，最大 10MB',
    emptyState: '暂无简历。上传第一份简历开始使用。',
    pages: '页',
    download: '下载',
    downloading: '下载中…',
    replace: '替换',
    replacing: '替换中…',
    delete: '删除',
    deleting: '删除中…',
    replaceTitle: '替换简历',
    replaceHint: '选择新的 PDF 文件替换当前简历。',
    chooseFile: '选择文件'
  },
  jobRecommendations: {
    back: '← 返回',
    title: '职位推荐',
    subtitle: '根据您的简历获取职位推荐',
    emptyPrompt: '根据您的简历获取职位推荐。',
    greeting: '你好，我是你的职业助手',
    newChat: '新对话',
    closeSidebar: '关闭侧边栏',
    openSidebar: '打开侧边栏',
    modeJobRecommendations: '职位推荐',
    modeSkillAdvice: '技能建议',
    inputPlaceholderSlash: '输入消息或按 / 切换模式…',
    suggestedPrompt: '为我推荐职位',
    suggestedPromptSkillAdvice: '我应该提升哪些技能？',
    suggestedPrompt1: '为我推荐职位',
    suggestedPrompt2: '我应该提升哪些技能？',
    suggestedPrompt3: '查找与我经验匹配的职位',
    suggestedPrompt4: '推荐相关职业方向',
    suggestedPrompt5: '帮我准备面试',
    suggestedPrompt6: '将我的简历与职位要求对比',
    viewJob: '查看职位 →',
    parsingPdf: '正在解析 PDF…',
    findingJobs: '正在查找职位…',
    loadingSkillAdvice: '正在分析技能…',
    loadingInterviewDebrief: '正在处理笔记…',
    loadingDefault: '正在处理…',
    tryAgain: '重试',
    provideResume: '提供您的简历：',
    uploadPdf: '上传简历 (PDF)',
    attachResume: '附加简历 (PDF)',
    pasteText: '粘贴简历文本',
    pastePlaceholder: '请在此粘贴简历内容…',
    usePaste: '使用此简历',
    resumeAttached: '已附加简历',
    usingSavedResume: '使用已保存的简历',
    inputPlaceholder: '输入获取职位推荐…',
    send: '发送',
    showReasoning: '显示推理',
    hideReasoning: '隐藏推理',
    noReasoning: '此步骤暂无推理内容。',
    humorousResumeTitle: '幽默简历',
    copyHumorousResume: '复制',
    openInEditor: '在编辑器中打开',
    showHumorousResume: '显示幽默简历',
    copiedToClipboard: '已复制到剪贴板',
    bestMatches: '最佳匹配',
    relatedRoles: '相关职位',
    stretchOpportunities: '进阶机会',
    youMightAlsoConsider: '您可能还会感兴趣',
    whyThisJob: '为什么推荐这个职位？',
    explainLoading: '加载中…',
    explainError: '无法加载说明，请重试。',
    explainNeedResume: '请先提供简历以查看推荐理由。',
    titleInterviewDebrief: '面试复盘',
    subtitleInterviewDebrief: '记录、总结并从最近的面试中学习。',
    emptyPromptInterviewDebrief: '分享您的面试经历，获得总结与可执行的改进建议。',
    suggestedPromptInterviewDebrief: '我想复盘刚才的面试',
    inputPlaceholderInterviewDebrief: '分享面试经历或查看过往复盘…',
    agentStep: {
      thinking: '思考中…',
      ask_user_start: '正在询问信息',
      ask_user_done: '已询问信息',
      capture_preferences_start: '正在保存偏好',
      capture_preferences_done: '已保存偏好',
      load_profile_start: '正在加载档案',
      load_profile_done: '档案已加载',
      parse_resume_start: '正在解析简历',
      parse_resume_done: '简历已解析',
      search_jobs_start: '正在搜索职位…',
      search_jobs_done: '已搜索 {n} 个职位',
      search_jobs_multi_start: '正在搜索职位…',
      search_jobs_multi_done: '已搜索 {n} 个职位',
      rank_and_filter_jobs_start: '正在排序职位…',
      rank_and_filter_jobs_done: '已排序 {n} 个职位',
      attempt_completion_start: '正在准备结果…',
      attempt_completion_done: '完成',
      use_skill_start: '正在加载技能…',
      use_skill_done: '技能已加载'
    },
    exportToNotion: '导出到 Notion',
    voice: {
      playAudio: '朗读',
      stopAudio: '停止朗读',
      loadingAudio: '加载音频中...',
      audioError: '音频播放失败',
      voiceInput: '语音输入',
      voiceInputListening: '正在聆听...',
      voiceInputStop: '停止聆听',
      voiceNotEnabled: '语音功能暂不可用',
      conversationMode: '语音对话',
      conversationModeStop: '结束语音对话',
      stateListening: '正在聆听...',
      stateProcessing: '正在思考...',
      stateSpeaking: '正在朗读...',
      interrupt: '打断'
    }
  },
  auth: {
    login: '登录',
    register: '注册',
    close: '关闭',
    dontHaveAccount: '还没有账号？',
    registerHere: '立即注册',
    alreadyHaveAccount: '已有账号？',
    verificationNotice: '📧 注册后将收到验证邮件。',
    username: '用户名',
    usernamePlaceholder: '请选择用户名',
    email: '邮箱',
    // Literal {'@'} so vue-i18n message format does not parse @ as linked message
    emailPlaceholder: "your{'@'}email.com",
    firstName: '名',
    firstNamePlaceholder: '名',
    lastName: '姓',
    lastNamePlaceholder: '姓',
    password: '密码',
    passwordPlaceholderLogin: '请输入密码',
    passwordPlaceholderRegister: '请设置密码',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    processing: '处理中...',
    needVerifyEmail: '需要验证邮箱？',
    clickHere: '点击这里',
    resetPassword: '重置密码',
    resetPasswordIntro: '请输入邮箱，我们将发送重置链接。',
    sendResetLink: '发送重置链接',
    sending: '发送中...',
    cancel: '取消',
    wechatLogin: '微信登录',
    wechatScanPrompt: '使用微信扫码登录',
    wechatQRAlt: '微信二维码',
    generatingQR: '正在生成二维码...',
    continueWithGoogle: '使用 Google 继续',
    or: '或',
    scanQRWithWeChat: '使用微信扫码',
    qrScannedConfirm: '已扫码，请在设备上确认。',
    passwordRequirement: '至少 8 位，需包含大小写字母、数字和特殊字符',
    rule: {
      minLength: '至少 8 个字符',
      uppercase: '一个大写字母',
      lowercase: '一个小写字母',
      number: '一个数字',
      specialChar: "一个特殊字符（!{'@'}#$%...）"
    },
    passwordStrength: {
      weak: '弱',
      medium: '中',
      good: '良好',
      strong: '强'
    }
  },
  credits: {
    credits: '积分',
    lowBalanceWarning: '积分不足',
    history: '历史',
    viewCreditHistory: '查看积分历史',
    insufficientTitle: '积分不足',
    youNeed: '此服务需要',
    creditsToUse: '积分。',
    yourBalance: '当前余额：',
    youNeedMore: '还需',
    moreCredits: '积分。',
    service: '服务：',
    inviteToEarn: '邀请好友获取积分，继续使用服务。',
    inviteFriendsToEarn: '邀请好友获取积分',
    gotIt: '知道了',
    creditHistory: '积分历史',
    loadingHistory: '正在加载交易记录...',
    retry: '重试',
    noTransactionHistory: '暂无交易记录',
    transaction: '交易',
    previous: '上一页',
    next: '下一页',
    showing: '显示',
    of: '共'
  },
  invitation: {
    sendInvitation: '发送邀请',
    emailAddress: '邮箱地址',
    nameOptional: '姓名（选填）',
    friendNamePlaceholder: '好友姓名',
    personalMessageOptional: '个人留言（选填）',
    personalMessagePlaceholder: '添加个人留言...',
    cancel: '取消',
    sendInvitationBtn: '发送邀请',
    sending: '发送中...'
  },
  legal: {
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    loadingDocument: '正在加载文档...',
    failedToLoad: '加载文档失败',
    failedToLoadRetry: '加载文档失败，请重试。',
    close: '关闭'
  },
  resetPassword: {
    validatingToken: '正在验证重置链接',
    pleaseWaitValidate: '正在验证您的密码重置链接，请稍候...',
    invalidOrExpiredLink: '链接无效或已过期',
    invalidLinkMessage: '该密码重置链接无效或已过期。重置链接有效期为 24 小时。',
    requestNewResetLink: '重新获取重置链接',
    goToLogin: '去登录',
    resetYourPassword: '重置密码',
    enterNewPasswordBelow: '请在下方输入新密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    passwordRequirement: '至少 8 位，包含大小写字母、数字和特殊字符',
    resettingPassword: '正在重置...',
    resetPasswordBtn: '重置密码',
    cancel: '取消',
    successTitle: '密码重置成功！',
    successMessage: '您的密码已重置，请使用新密码登录。',
    loginWithNewPassword: '使用新密码登录'
  },
  editor: {
    generatingPdf: '正在生成 PDF',
    aiHumorousResumeGenerator: 'AI 幽默简历生成器',
    resumeReimagined: '简历，焕新呈现。',
    flowSubtitle: '上传简历 PDF，一键生成幽默版。或发现与您匹配的职位。',
    ctaDescFree: '免费试用。上传 PDF → AI 幽默改写 → 下载。',
    ctaJobDesc: '根据简历匹配职位。AI 智能推荐与解析。',
    switchToLegacyEditor: '切换到旧版编辑器',
    resumeEditor: '简历编辑器',
    tryNewFlow: '体验新版流程',
    exportPdf: '导出 PDF',
    newResume: '新建简历',
    resumeContent: '简历内容',
    chooseDifferentFile: '选择其他文件',
    tipsForBestResults: '最佳效果提示：',
    tipCleanPdf: '使用清晰的文本型 PDF（非扫描图片）',
    tipSelectable: '确保 PDF 中的文字可选中',
    tipMaxSize: '最大文件大小：10MB',
    tipOcr: '扫描件请先用 OCR 软件处理',
    processingPdf: '正在处理 PDF',
    transformingToHumorous: '正在转换为幽默风格',
    startingPipeline: '正在启动流水线...',
    startingPdfProcessing: '正在开始处理 PDF...',
    transformationComplete: '转换完成，正在生成 PDF...',
    pipelineCompleted: '流水线完成！',
    resumeBeingGenerated: '正在生成您的幽默简历...',
    resumeReadyToDownload: '幽默简历已就绪，可下载。',
    howItWorks: '使用流程',
    uploadStep: '上传简历 PDF',
    processStep: 'AI 提取文本',
    transformStep: '幽默风格改写',
    generateStep: '生成并下载 PDF',
    benefits: '特点',
    benefitUploadNoLogin: '无需登录即可上传',
    benefitLoginRequired: '生成需登录',
    benefitAutomated: '全自动流程',
    benefitAIPowered: 'AI 幽默改写',
    benefitProfessionalPdf: '专业 PDF 排版',
    uploadResumePdf: '上传简历 PDF',
    dragAndDropOrClick: '拖拽或点击选择文件',
    supportsPdf10mb: '支持最大 10MB 的 PDF',
    changeFile: '更换文件',
    humorIntensity: '幽默程度：',
    subtle: '轻微',
    medium: '中等',
    overt: '明显',
    preserveKeyInfo: '保留关键信息',
    useAILayoutEnhancement: '使用 AI 版式增强',
    aiServiceNotAvailable: '（AI 服务不可用）',
    startGeneration: '开始生成',
    processing: '处理中...',
    uploadYourResumePdf: '上传简历 PDF',
    dragDropOrClick: '将 PDF 拖到此处或点击选择',
    removeFile: '移除文件',
    processResume: '处理简历',
    switchToPreview: '切换到预览',
    switchToEdit: '切换到编辑',
    previewBtn: '预览',
    editBtn: '编辑',
    bold: '粗体',
    italic: '斜体',
    heading: '标题',
    bulletList: '列表',
    words: '字',
    addComment: '添加评论',
    startEditingPlaceholder: '在此开始编辑简历...',
    selected: '已选：',
    clearSelection: '清除选择',
    aiAnalyzing: 'AI 正在分析简历...',
    noSuggestionsYet: '暂无建议',
    selectTextAndGetAI: '选中简历中的文字并点击「获取 AI 建议」开始。',
    tryAskingAI: '可以请 AI：',
    makeMoreConcise: '精简表述',
    strongerActionVerbs: '使用更强动词',
    improveGrammar: '改进语法与清晰度',
    addMetrics: '添加可量化结果',
    aiSuggestions: 'AI 建议',
    copySuggestions: '复制建议',
    applyAllSuggestions: '应用全部建议',
    requestCustomEdit: '请求自定义修改',
    tellAIWhatToChange: '告诉 AI 你想修改的内容...',
    submitToAI: '提交给 AI',
    cancel: '取消',
    commentsAndEdits: '评论与修改',
    addCommentPlaceholder: '添加你想改进的评论...',
    addCommentBtn: '添加评论',
    clear: '清空',
    resolved: '已解决',
    pending: '待处理',
    markAsPending: '标记为待处理',
    markAsResolved: '标记为已解决',
    editWithAI: 'AI 修改',
    deleteComment: '删除评论',
    aiResponse: 'AI 回复：',
    generatingHumorousResume: '正在生成幽默简历',
    status: '状态：',
    jobId: '任务 ID：',
    close: '关闭',
    retry: '重试',
    downloadPdf: '下载 PDF',
    pipelineId: '流水线 ID：',
    started: '开始：',
    completed: '完成：',
    funnyResumePreview: '幽默简历预览',
    makeItFunny: '变幽默',
    makingItFunny: '正在变幽默...',
    transformingResumeStyle: '正在转换简历风格',
    aiPerformingSTAR: 'AI 正在进行 STAR 分析...',
    starAnalysisSubtext: '分析每段工作经历约需 1–2 分钟',
    analyzingResumeStructure: '正在分析简历结构与经历...',
    noSTARAnalysisYet: '暂无 STAR 分析',
    starAnalysisIntro: '使用 STAR 法（情境、任务、行动、结果）获取工作经历详细分析。',
    performSTARAnalysis: '执行 STAR 分析',
    whatIsSTAR: '什么是 STAR 分析？',
    situation: '情境',
    situationDesc: '你面对的背景或挑战',
    task: '任务',
    taskDesc: '你的具体职责或目标',
    action: '行动',
    actionDesc: '你采取的具体行动',
    result: '结果',
    resultDesc: '可衡量的结果',
    starAnalysisHelps: '此分析有助于发现简历中的表述问题与改进点。',
    starAnalysisReport: 'STAR 分析报告',
    copyAnalysis: '复制分析',
    downloadAsPdf: '下载为 PDF',
    refreshAnalysis: '刷新分析',
    analysisLanguage: '分析语言：',
    downloadAnalysis: '下载分析',
    synthesizeResume: '综合成简历',
    reanalyze: '重新分析',
    insufficientCreditsService: '幽默简历 PDF 生成',
    useAsyncProcessingLongResumes: '使用异步处理（推荐用于较长简历）',
    original: '原文',
    transformed: '改写后',
    applyTransformation: '应用改写',
    tryDifferent: '换一种',
    regenerating: '重新生成中...',
    humorousResumeTransformation: '幽默简历改写'
  },
  acceptInvitation: {
    youreInvited: '您被邀请了！',
    hasInvitedYou: '邀请您加入 AI4Resume',
    emailAddress: '邮箱地址',
    emailFromInvitation: '此邮箱来自邀请，不可修改。',
    username: '用户名',
    usernameHint: '3-30 个字符，仅限字母、数字和下划线',
    firstName: '名',
    lastName: '姓',
    password: '密码',
    confirmPassword: '确认密码',
    passwordRequirement: '至少 8 位，包含大小写字母、数字和特殊字符',
    creatingAccount: '正在创建账号...',
    createAccountAndJoin: '创建账号并加入',
    invitationExpiresOn: '此邀请将于 {date} 过期',
    validatingInvitation: '正在验证邀请...',
    invalidInvitation: '邀请无效',
    goToHome: '返回首页'
  },
  verification: {
    emailVerificationRequired: '需要验证邮箱',
    emailVerifiedSuccess: '邮箱验证成功！',
    continueToApplication: '进入应用',
    verificationFailed: '验证失败',
    sendNewVerificationEmail: '发送新验证邮件',
    verificationEmailQueued: '验证邮件已排队',
    queuedMessage: '验证邮件已加入队列，配额可用时将自动发送。',
    positionInQueue: '排队位置：',
    calculating: '计算中...',
    estimatedWait: '预计等待：',
    queueNote: '轮到您时会自动发送，无需操作。',
    checking: '检查中...',
    refreshStatus: '刷新状态',
    didntReceiveEmail: '没收到邮件？请检查垃圾箱或重新请求验证邮件。',
    canRequestIn: '可于',
    sendVerificationEmail: '发送验证邮件',
    sending: '发送中...',
    checkingStatus: '正在检查验证状态...',
    verificationSentTo: '验证邮件已发送至：',
    checkInboxHint: '请查收邮件并点击验证链接。',
    whatToDoNext: '下一步：',
    step1CheckEmail: '查收验证邮件',
    step2ClickLink: '点击邮件中的验证链接',
    step3ReturnOrRefresh: '返回本页或刷新页面',
    linkExpiresNote: '验证链接 24 小时内有效，过期后可重新请求。',
    changeEmailAddress: '更换邮箱',
    contactSupport: '联系支持',
    changeEmailTitle: '更换邮箱',
    changeEmailIntro: '输入新邮箱以接收验证邮件。',
    newEmailAddress: '新邮箱地址',
    newEmailPlaceholder: 'new@email.com',
    updating: '更新中...',
    updateEmail: '更新邮箱',
    enterVerificationCode: '输入验证码',
    codeSentTo: '我们已向',
    codeExpiresIn: '验证码有效期：',
    resendCode: '重新发送',
    resendCodeIn: '重新发送（{time}）',
    sendingCode: '发送中...',
    verifyingCode: '验证中...',
    attemptsRemaining: '次剩余'
  },
  notion: {
    connect: '连接 Notion',
    disconnect: '断开连接',
    connected: '已连接',
    disconnected: '未连接',
    connectedAs: '已连接：{workspace}',
    connectNotion: '连接 Notion',
    disconnectNotion: '断开 Notion',
    privacyNote: 'Career Copilot 仅会访问您选择的页面标题和内容，用于个性化建议。',
    errorDenied: 'Notion 访问被拒绝。',
    errorGeneric: '连接 Notion 失败，请重试。',
    disconnectConfirm: '断开 Notion 连接？您可以随时重新连接。',
    settings: '设置',
    integrations: '集成',
    exportToNotion: '导出到 Notion',
    exportSuccess: '对话已导出到 Notion。',
    exportErrorNotConnected: '请先在设置中连接 Notion 后再导出。',
    exportErrorFailed: '导出失败，请检查目标页面后重试。',
    exportErrorForbidden: '您没有权限导出此对话。',
    exportErrorNotFound: '未找到该对话。',
    exportDestinationLabel: 'Notion 页面 ID',
    exportDestinationPlaceholder: '粘贴 Notion 页面 ID（从页面 URL 中获取）',
    exportConsent: '将此对话导出到 Notion，内容将写入您选择的页面。',
    connectNotionFirst: '请先连接 Notion',
    exportModalTitle: '导出到 Notion',
    exporting: '导出中…',
    openInNotion: '在 Notion 中打开'
  },
  expandSearch: {
    alsoRecommending: '也为您推荐以下相关职位',
    expandedFromCity: '已扩展搜索范围（原：{city}）',
    noExactMatch: '未找到完全匹配的职位，为您展示相关结果'
  },
  errors: {
    passwordMinLength: '密码至少需要 8 个字符',
    passwordMaxLength: '密码不能超过 100 个字符',
    passwordUppercase: '密码必须包含至少一个大写字母',
    passwordLowercase: '密码必须包含至少一个小写字母',
    passwordNumber: '密码必须包含至少一个数字',
    passwordSpecialChar: '密码必须包含至少一个特殊字符',
    passwordRequirementsCombined: '密码需包含大小写字母、数字和特殊字符',
    passwordMismatch: '两次密码不一致',
    passwordRequired: '请输入密码',
    emailRequired: '请输入邮箱',
    emailInvalid: '邮箱格式不正确',
    emailExists: '该邮箱已被注册',
    usernameRequired: '请输入用户名',
    usernameMinLength: '用户名至少需要 3 个字符',
    usernameMaxLength: '用户名不能超过 30 个字符',
    usernameInvalidChars: '用户名只能包含字母、数字、下划线和连字符',
    usernameExists: '该用户名已被使用',
    invalidCredentials: '邮箱或密码错误',
    rateLimited: '请求过于频繁，请稍后再试',
    weakPassword: '密码不符合安全要求',
    resetTokenMissing: '重置令牌缺失',
    resetFailed: '密码重置失败',
    invalidInvitationLink: '无效的邀请链接',
    invalidOrExpiredInvitation: '邀请无效或已过期',
    failedToValidateInvitation: '验证邀请失败',
    failedToCreateAccount: '创建账号失败，请重试。',
    firstNameRequired: '请输入名字',
    lastNameRequired: '请输入姓氏',
    networkError: '网络错误：无法连接到服务器',
    serverError: '服务器出现问题，请稍后再试。',
    unknownError: '发生未知错误，请重试。'
  }
}
